"use client";
import { useRouter } from "next/navigation";
import { useState } from "react";

// Reading languages available per market. Only markets with genuine multilingual
// content get a toggle; everywhere else is English-only (no confusing switch).
const LANGS_BY_COUNTRY: Record<string, { code: string; label: string }[]> = {
  BE: [{ code: "nl", label: "NL" }, { code: "en", label: "EN" }],
  NL: [{ code: "nl", label: "NL" }, { code: "en", label: "EN" }],
  // GB, DK, SE, IN, EU, WW -> English only (omitted => no toggle shown)
};

function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
}

export function LocaleSwitcher({ country, locale }: { country: string; locale: string; countries?: { code: string; label: string }[] }) {
  const router = useRouter();
  const [l, setL] = useState(locale);

  const langs = LANGS_BY_COUNTRY[(country || "").toUpperCase()];
  // No toggle for English-only regions.
  if (!langs) return null;

  const pickLocale = (code: string) => {
    setL(code);
    setCookie("locale", code);
    router.refresh();
  };

  return (
    <div className="flex items-center gap-3">
      <span className="w-px h-3.5 bg-black/[0.06]" />
      <div className="flex items-center gap-1">
        {langs.map((x) => (
          <button
            key={x.code}
            onClick={() => pickLocale(x.code)}
            className={`font-mono text-[10px] px-1.5 py-0.5 rounded transition-colors ${
              l === x.code ? "text-sh-red font-bold" : "text-sh-tx3 hover:text-sh-tx2"
            }`}
          >
            {x.label}
          </button>
        ))}
      </div>
    </div>
  );
}
